import { BizData } from '../data';
import { View } from '../view';
import { AsyncTask } from '../async-task';
import { Import } from '../import';
export namespace DataPort {
    /**
     * 导入导出类型
     */
    export enum DataPortType {
        Import = 1,
        Export = 2,
    }
    export namespace Request {
        // 导出数据请求结构体
        export interface IExportQueryBizDataRequest {
            SchemaCode: string; // 表单编码
            ViewPageId?: string; // 视图页Id
            Scope: number; // 数据范围类型
            PageIndex?: number; // 分页索引
            PageSize?: number; // 分页大小
            SortBy?: string; // 排序字段
            SortDirection?: View.SortDirection; // 排序方式
            Properties?: BizData.IProperty[]; // 是否需要返回属性列表
            RequireCount?: boolean; // 是否需要返回总数
            IncludeDefaultFilter?: boolean; // 是否包含默认筛选
            Filter: Record<string, any>; // 筛选条件
        }

        // 导出任务请求参数结构
        export interface IExportTaskRequest {
            AsyncTaskId: string;
            ObjectIds: string[];
            QueryBizDataRequest: {
                SchemaCode: string; // 表单编码
                ViewPageId?: string; // 视图页Id
                Scope: number; // 数据范围类型
                PageIndex?: number; // 分页索引
                PageSize?: number; // 分页大小
                SortBy?: string; // 排序字段
                SortDirection?: string; // 排序方式
                Properties?: string; // 是否需要返回属性列表
                RequireCount?: boolean; // 是否需要返回总数
                IncludeDefaultFilter?: boolean; // 是否包含默认筛选
                Filter: Record<string, any>; // 筛选条件
            };
        }
    }
    export namespace Response {
        // 导出模板字段信息
        export interface IDataPortProperty {
            propertyName: string;
            displayName: string;
            visible: boolean;
            editable: boolean;
            required: boolean;
            printable: boolean;
        }

        // 新版导出模板返回模型
        export interface IDataPortColumnsModel {
            schemaCode: string;
            draftFieldPermissions: Record<string, IDataPortProperty>; // 草稿状态字段权限
            effectiveFieldPermissions: Record<string, IDataPortProperty>; // 生效状态字段权限
        }

        // 导入导出任务记录模型
        export interface ITaskRecordModel {
            objectId: string; // 任务Id
            title: string; // 任务标题
            totalCount: number; // 总数量
            finishedCount: number; // 已完成数量
            asyncTaskState: AsyncTask.TaskState; // 异步任务状态
            createdBy: string; // 创建人
            errorMessage: string; // 错误信息
            createdTime: string; // 创建时间
            modifiedTime: string; // 修改时间
            errorFilePath: string; // 错误文件路径
            importBoCount: number; // 已处理的导入数据总量
            importType: Import.ImportType; // 导入类型
            successBoCount: number; // 已导入成功的业务数据量
            errorBoCount: number; // 已导入失败的业务数据量
            downloadErrorExcelFile: string; // 下载错误Excel文件的URL
            downloadErrorCsvFile: string; // 下载错误CSV文件的URL
            downloadFilePath: string; // 下载成功文件的URL
            subTableErrorCount: Record<string, number>; // 子表错误记录
            subTableSuccessCount: Record<string, number>; // 主表错误记录
            runningTime: string; // 任务开始时间
            aheadTaskCount: number; // 前面还在等待的任务数
        }

        // 获取导入导出任务记录返回模型
        export interface IDataPortTaskRecordResponse {
            totalCount: number;
            waitingCount: number;
            taskRecords: ITaskRecordModel[];
        }
    }
}
